/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Caption_ChosenInputs */

const vi_carrier_legacy_caption_chosen = /** @type {(inputs: Carrier_Legacy_Caption_ChosenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã chọn`)
};

/**

* @param {Carrier_Legacy_Caption_ChosenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_caption_chosen = /** @type {((inputs?: Carrier_Legacy_Caption_ChosenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Caption_ChosenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_caption_chosen(inputs)
});